import video from '../blocks/video';
import expandingVideo from '../blocks/expanding-video';
import TextFull from '../util/textFull';
import styleSelect from 'styleselect';
import menu from '../modules/menu';
import mobileMenu from '../modules/mobile-menu';
import 'animation.gsap'
import gravityForms from '../gravity-forms';
import disableAnimationForDevices from '../disable-animation-for-devices'
import VHChromeFix from '../util/vhChromeFix';
import Cursor from '../modules/cursor';
import LazyLoader from '../modules/lazy-loader';
import LazyLoaderVideo from '../modules/lazy-loader-video';
import jump from 'jump.js';
import FadeAnimations from '../modules/fade-animations';
import BackToTop from '../modules/back-to-top';
import objectFitImages from 'object-fit-images';
import videoColumns from '../blocks/image_video-columns';
import carousel from '../blocks/carousel';
import imagesLoaded from 'imagesloaded';
import SlidingImages from '../blocks/sliding-images';
import beforeAfter from '../blocks/before-after';
import CaseStudiesFilter from '../blocks/case-studies';
import Barba from 'barba.js';

export default {
  init() {


    if(document.querySelector('.sub-navigation') && document.querySelector('.casestudies')) {
      if(window.caseStudiesFilter == null) {
        // Create an instance of the CaseStudiesFilter class
        window.caseStudiesFilter = new CaseStudiesFilter();


        // Reinitialize components on Barba page transitions
        Barba.Dispatcher.on('transitionCompleted', function () {
          window.caseStudiesFilter.initComponents();
        });


        let lastWidth = window.innerWidth; // Store the initial window width
        const threshold = 100; // Set the threshold value (e.g., 100px)

        window.addEventListener('resize', () => {
          const currentWidth = window.innerWidth;
          if (Math.abs(currentWidth - lastWidth) >= threshold) {
            // Only execute logic if the width change exceeds the threshold
            lastWidth = currentWidth; // Update the last known width
            window.caseStudiesFilter.initComponents();
          }
        });

        // Call the function to initialize components when the page first loads
        window.caseStudiesFilter.initComponents();
      }
    }


    BackToTop.init();

    var col = new videoColumns();
    col.init();

    // set plyr colour scheme
    let bgColor = $('.border span').css('backgroundColor')
    var r = document.querySelector(':root');
    r.style.setProperty('--plyr-color-main', bgColor);

    /***********************************************
    * Configure Vertical height fix for mobile
    * (Stops including address bar in calculation)
    ************************************************/
    let options = [
      {
        selector: '#loading',
        vh: 100,
      },
      {
        selector: '.fs-video',
        vh: 100,
      },
      {
        selector: '.pop-over-menu',
        vh: 100,
      },
    ];
    new VHChromeFix(options);

    /******************************
    * Stop barba.js fully re-loading
    * page when same link is clicked
    *******************************/
    var links = document.querySelectorAll('a[href]');
    var cbk = function(e) {
      if(e.currentTarget.href === window.location.href) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    for(var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', cbk);
    }

    /******************************
    * All devices
    *******************************/
    new LazyLoader();
    new LazyLoaderVideo();
    gravityForms.init();
    expandingVideo.init();

    video.init();
    menu.init();
    mobileMenu.init();

    imagesLoaded('.carousel', function() {
      $('.carousel').each( (index, element) => {
        new carousel(element);
      });
    });

    if(! $('#pointer').length ) {
      let cursor = new Cursor();
      window.cursor = cursor;
    }

    /*******************************************
    * Old Browsers / Devices: Degrade features.
    ********************************************/
    if( disableAnimationForDevices.isDisabledDevice() ){
      $('.fade-in').removeClass('fade-in');
      window.cursor.mobileInit();
    }

    /******************************
    * Newer Browsers / Devices
    * - Show Animated Cursor
    * - Fade in sections in view
    *******************************/
   if(! disableAnimationForDevices.isDisabledDevice() ){
      new FadeAnimations('.fade-in');
      window.cursor.desktopInit();
    }

    /******************************
    * Common items
    *******************************/
    if( $('.page-header__background-text').length ) {
      new TextFull($('.page-header__background-text')[0]);
    }

    if( $('.heading__negative-top').length ) {
      $('.heading__negative-top').each(function(){
        var text = $(this).text();
        text = text.replace(" ", "<br><span></span>");
        $(this).html(text);
      });
    }

    if( $('.contact-form__select').length ) {
      $('.contact-form__select').each(function(){
        styleSelect(this);
      });
    }

    $('[data-accordion-trigger]').on('click', function() {
      $(this).parent().toggleClass('active');
    });

    $('[data-accordion-content]').on('click', function(e) {
      if( $(this).attr('href') == '' ) {
        e.preventDefault();
        jump('.contact-form__wrapper');
      }
    });

    if($('.mobile-navigation__link--active').length) {
      $('.select-text').text( $('.mobile-navigation__link--active').text() );
    }

    /* Mobile Select Box */
    $('[data-mobile-trigger]').on('click', function(e){
      e.preventDefault();
      $('.mobile-navigation__list').toggleClass('mobile-navigation__list--active');
    });

    /* remove play cursors from videos with no iframe - It's/was possible to add a video placeholder image without a video url */
    $('.expanding-video').each(function() {
      if(! $(this).find('iframe').length ) {
        $(this).removeAttr('data-cursor');
      }
    });

    objectFitImages(null, {watchMQ: true});

    imagesLoaded('.sliding-images', function() {
      $('.sliding-images').each( (index, slidingImage) => {
        new SlidingImages(slidingImage);
      });
    });

    imagesLoaded('.before-after', function() {
      beforeAfter.init();
    });


    // animation
    window.setTimeout(()=> {
      $('.header-fade').addClass('header-fade--in');
      $('.header-down').addClass('header-down--in');
    }, 3200)


    window.setTimeout(()=> {
      $('.main-fade').addClass('main-fade--in');
      $('.main-up').addClass('main-up--in');
    }, 2500)


    window.setTimeout(()=> {
      $('.home__video-mask').addClass('home__video-mask--in');
    }, 4000)

    $('.home__video').on("stopvideo", () => {
      $('.home__title').removeClass('main-up--out');
      $('.home__title').addClass('main-up--in');
    });

    $('.home__video').on("initplay", () => {
      $('.home__title').removeClass('main-up--in');
      $('.home__title').addClass('main-up--out');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js